
import commonImg from '~/components/common/commonImg.vue'
export default {
  name: 'SlideShow',
  components: {
    'common-img': commonImg
  },
  props: {
    list: {
      type: Array,
      default: () => {}
    },
    type: {
      type: String,
      default: '1'
    },
    urlName: {
      type: String,
      default: ''
    },
    ico: {
      type: String,
      default: ''
    },
    dealerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      arrowBtnIndex: 0
    }
  },
  mounted() {},
  methods: {
    prev() {
      // console.log(this.$refs.img)
      if (this.$refs.img.activeIndex != 0) {
        this.arrowBtnIndex = this.$refs.img.activeIndex - 1
        this.$refs.img.prev()
      }
    },
    next() {
      // console.log(this.$refs.img.activeIndex)
      if (this.$refs.img.activeIndex != this.list.length - 1) {
        this.arrowBtnIndex = this.$refs.img.activeIndex + 1
        this.$refs.img.next()
      }
    }
  }
}
